var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6852 0H9.26956C4.16 0 0 4.16 0 9.26956V16.7304C0 21.84 4.16 26 9.26956 26H16.7304C21.84 26 26 21.84 26 16.7304V9.26956C25.9548 4.16 21.7948 0 16.6852 0ZM23.6939 16.6852C23.6939 20.5287 20.5287 23.6939 16.6852 23.6939H9.26956C5.42609 23.6939 2.26087 20.5287 2.26087 16.6852V9.26956C2.26087 5.42609 5.42609 2.26087 9.26956 2.26087H11.847V13.0226L8.22956 9.40522C7.77739 8.95304 7.05391 8.95304 6.64696 9.40522C6.19478 9.85739 6.19478 10.5809 6.64696 10.9878L12.1635 16.5043C12.3896 16.7304 12.6609 16.8209 12.9774 16.8209C13.2939 16.8209 13.5652 16.7304 13.7913 16.5043L19.3078 10.9878C19.76 10.5357 19.76 9.81217 19.3078 9.40522C18.8557 8.95304 18.1322 8.95304 17.7252 9.40522L14.1078 13.0226V2.26087H16.6852C20.5287 2.26087 23.6939 5.42609 23.6939 9.26956V16.6852Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadFile);
export default __webpack_public_path__ + "static/media/download-file.44daeafb975a12d30eced99aad1c69d9.svg";
export { ForwardRef as ReactComponent };